import { Link } from "react-router-dom"
import ArrowDropUpOutlinedIcon from "@mui/icons-material/ArrowDropUpOutlined"
import HotelIcon from "@mui/icons-material/Hotel"
import LocalCafeIcon from "@mui/icons-material/LocalCafe"
import GroupIcon from "@mui/icons-material/Group"
import LocalActivityIcon from "@mui/icons-material/LocalActivity"
import useFetch from "../../hooks/useFetch"
import "./widget.css"

const config = {
  hotels: {
    title: "Hôtels",
    icon: <HotelIcon style={{ fontSize: 18 }} />,
    accentColor: "#6366f1",
    bgColor: "#ede9fe",
    url: "/hotels/",
    endpoint: "https://api.moroccool.com/api/hotels/countHotels",
  },
  cafes: {
    title: "Cafés & Restaurants",
    icon: <LocalCafeIcon style={{ fontSize: 18 }} />,
    accentColor: "#10b981",
    bgColor: "#d1fae5",
    url: "/cafes/",
    endpoint: "https://api.moroccool.com/api/cafes/countCafes",
  },
  events: {
    title: "Événements",
    icon: <LocalActivityIcon style={{ fontSize: 18 }} />,
    accentColor: "#f59e0b",
    bgColor: "#fef3c7",
    url: "/events/",
    endpoint: "https://api.moroccool.com/api/events/countEvents",
  },
  users: {
    title: "Utilisateurs",
    icon: <GroupIcon style={{ fontSize: 18 }} />,
    accentColor: "#ef4444",
    bgColor: "#fee2e2",
    url: "/users/",
    endpoint: "https://api.moroccool.com/api/users/countUsers",
  },
}

const Widget = ({ type }) => {
  const { title, icon, accentColor, bgColor, url, endpoint } = config[type]
  const { data, loading } = useFetch(endpoint)
  const count = data || 0
  const percentage = 24

  return (
    <Link to={url} className="widget-card" style={{ "--accent": accentColor }}>
      <div className="widget-accent-bar" style={{ background: accentColor }} />

      <div className="widget-top">
        <span className="widget-label">{title}</span>
        <div className="widget-icon" style={{ background: bgColor, color: accentColor }}>
          {icon}
        </div>
      </div>

      <div className="widget-value">
        {loading ? (
          <span className="widget-skeleton" />
        ) : (
          count.toLocaleString("fr-FR")
        )}
      </div>

      <div className="widget-footer">
        <span className="widget-trend" style={{ color: accentColor }}>
          <ArrowDropUpOutlinedIcon style={{ fontSize: 18 }} />
          +{percentage}%
        </span>
        <span className="widget-period">vs mois dernier</span>
      </div>
    </Link>
  )
}

export default Widget